import type { FC } from "react";

import { TableHead } from "@/components/ui/table";
import { cn } from "@/lib/utils";

import type { TableProps } from "./types";

const TableHeadCellCustom: FC<TableProps> = ({ children, classes }) => {
  return (
    <TableHead
      className={cn(
        "py-3.5 px-4 text-left text-xs text-gray-500 border-b border-gray-200",
        classes
      )}
    >
      {children}
    </TableHead>
  );
};

export default TableHeadCellCustom;
